/**
 * The Ingredients Garden section shows each ingredient's images across 4
 * separate picture frames, all sharing the same "img-st-N" class per index.
 * Bootstrap's native Tab component only activates the FIRST element matching
 * a given data-bs-target selector (it uses querySelector, not querySelectorAll),
 * so clicking an ingredient only updated one of the four frames. This manually
 * syncs all four frames together on click.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-bs-toggle="tab"][data-bs-target^=".img-st-"]');
    if (!trigger || !trigger.closest('.ingredient-accordion')) return;

    var targetClass = trigger.getAttribute('data-bs-target').slice(1); // "img-st-2"

    document.querySelectorAll('.picture-frame .tab-content').forEach(function (tabContent) {
      tabContent.querySelectorAll('.tab-pane').forEach(function (pane) {
        pane.classList.remove('active', 'show');
      });
      var match = tabContent.querySelector('.' + targetClass);
      if (match) match.classList.add('active', 'show');
    });
  });
})();
